var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "extrato-financeiro mt-4"
  }, [_c('b-card', [_c('h5', {
    staticClass: "mb-3"
  }, [_vm._v("Extrato")]), _c('b-table', {
    attrs: {
      "items": _vm.extrato,
      "fields": _vm.fields,
      "bordered": "",
      "striped": "",
      "responsive": "",
      "small": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(date)",
      fn: function fn(data) {
        return [_c('span', [_vm._v(" " + _vm._s(_vm.formatDate(data.item.date)) + " ")])];
      }
    }, {
      key: "cell(tipo)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.typeMap[data.item.tipo] || data.item.tipo) + " ")];
      }
    }, {
      key: "cell(valor)",
      fn: function fn(data) {
        return [_c('span', {
          class: {
            'text-danger': data.item.valor < 0,
            'text-success': data.item.valor > 0
          }
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(data.item.valor, 2)) + " ")])];
      }
    }, {
      key: "cell(saldo)",
      fn: function fn(data) {
        return [_c('strong', [_vm._v(_vm._s(_vm.numberToReal(data.item.saldo, 2)))])];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-end mt-2"
  }, [_c('strong', {
    staticClass: "mr-2"
  }, [_vm._v("Saldo final:")]), _c('strong', {
    staticClass: "text-dark"
  }, [_vm._v(_vm._s(_vm.numberToReal(_vm.saldoFinal, 2)))])]), _vm.hasMore ? _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.carregando,
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.buscarExtrato();
      }
    }
  }, [_vm.carregando ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "type": "border"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.carregando ? "Carregando..." : "Carregar mais") + " ")], 1)], 1) : _vm._e()], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };